import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LogIn, UserPlus, Sparkles } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface GuestOverlayProps {
    title?: string;
    description?: string;
    className?: string;
    showIcon?: boolean;
}

const GuestOverlay = ({ title, description, className = "", showIcon = true }: GuestOverlayProps) => {
    const { t } = useLanguage();

    return (
        <div className={`absolute inset-0 z-50 flex items-center justify-center p-6 bg-background/40 backdrop-blur-[6px] rounded-xl border border-white/20 shadow-2xl ${className}`}>
            <div className="max-w-md w-full bg-card/90 backdrop-blur-xl p-8 rounded-2xl border border-white/20 shadow-2xl text-center shadow-primary/10">
                {showIcon && (
                    <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6 border border-primary/30 shadow-lg shadow-primary/20">
                        <Sparkles className="h-8 w-8 text-primary animate-pulse" />
                    </div>
                )}
                <h3 className="text-2xl font-heading font-bold mb-3">
                    {title || t("เข้าสู่ระบบเพื่อเริ่มใช้งาน", "Login to Start Creating")}
                </h3>
                <p className="text-muted-foreground mb-8">
                    {description || t(
                        "เข้าร่วมกับเราเพื่อเข้าถึงเครื่องมือ AI ระดับโปรและเริ่มสร้างสรรค์ผลงานของคุณวันนี้",
                        "Join us to access professional AI tools and start creating your masterpiece today."
                    )}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/register" className="w-full sm:w-auto">
                        <Button variant="glow" className="w-full gap-2 px-8">
                            <UserPlus className="h-4 w-4" />
                            {t("สมัครฟรี", "Register Free")}
                        </Button>
                    </Link>
                    <Link to="/login" className="w-full sm:w-auto">
                        <Button variant="outline" className="w-full gap-2 bg-white/50 border-white/10 hover:bg-white/80 dark:bg-white/10 dark:hover:bg-white/20">
                            <LogIn className="h-4 w-4" />
                            {t("เข้าสู่ระบบ", "Login")}
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default GuestOverlay;
